

  import {defineComponent} from "vue";
  import {Link} from "@/domain/ui/Link";
  import {NamedRouting} from "@/domain/utils/NamedRouting";
  import Hashtag from "@/domain/product/Hashtag";

  export default defineComponent({
    name: 'navigator-component',
    props: ['navigatorCode', 'hashtagList'],
    data() {
      return {
        isExpandedHashtag: false,
        renderExpandButton: false,
        selectedIndex: 1,
        links: [
          new Link(new NamedRouting('HomeView'), "홈", "home"),
          new Link(new NamedRouting('ProductListView'), "상품", "product"),
          new Link(new NamedRouting('MyUsableTicketView'), "선물함", "my")
        ],
      }
    },
    methods: {
      selected(link: Link): string {
        if (link.code == this.navigatorCode) {
          return "is_sel";
        } else {
          return "";
        }
      },
      isProductListPage(): boolean {
        if (this.navigatorCode == 'product') {
          return true;
        }
        return false;
      },
      toggleExpandButton(): void {
        this.isExpandedHashtag = !this.isExpandedHashtag;
        this.$nextTick(() => {
          this.moveScroll();
        });

      },
      selectHashtag(hashtag: Hashtag, selectedIndex: number): void {
        if (hashtag.isSelected) {
          return;
        }

        this.$emit('changeHashtagOption', selectedIndex);
        this.selectedIndex = selectedIndex + 1;
        this.moveScroll();
      },
      changeWidth() {
        const hashtagWrapper: any = this.$refs.hashtagWrapper;
        if (hashtagWrapper !== undefined) {
          this.renderExpandButton = (hashtagWrapper.scrollWidth > hashtagWrapper.clientWidth);
        }
      },
      moveScroll() {
        const hashtagWrapper: any = this.$refs.hashtagWrapper;
        const moveTo = hashtagWrapper.querySelector(`li:nth-child(${this.selectedIndex})`).offsetLeft
            - hashtagWrapper.clientWidth / 2;
        hashtagWrapper.scrollTo({left: moveTo, behavior:'smooth'});
      }
    },
    computed: {
      expandButtonHelp(): string {
        return this.isExpandedHashtag ? "닫기" : "카테고리 펼치기";
      },
    },
    watch: {
      hashtagList: {
        deep: true,
        handler() {
          if (this.isExpandedHashtag) {
            return;
          }
          this.$nextTick(() => {
            this.changeWidth();
          });
        }
      }
    }

  });

